/* tslint:disable */
import styled from '@emotion/styled';
import React from 'react';

import withTracking from './withTracking';
import Hamburger from '../../icons/Hamburger';
import { theme } from '@kindur/components';
import NavbarLinks from './NavbarLinks';

const Container = styled('nav')<{ bannerHeight: number; distanceFromTop?: number, fixNav: boolean }>`
  background-color: #fff;
  box-shadow: ${(props) => (props.distanceFromTop ? '0 5px 3px rgba(0, 0, 0, 0.1)' : 'none')};
  position: ${p => p.fixNav ? 'fixed' : 'relative'};
  top: 0;
  width: 100%;
  z-index: 90;
`;
const NavContainer = styled('div')`
  left: 0;
  top: 0;
  width: 100%;
`;
const BurgerContainer = styled('a')`
  cursor: pointer;
  position: absolute;
  display: none;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);

  ${theme.breakpoints.tabletLandscapeDown} {
    display: inline-block;
  }
`;
const FlexContainer = styled('header')`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  height: 5rem;
  padding: 1rem 1.5rem;
  
  > * {
    font-size: 1.125rem;
    margin: 0 1rem; 
  }

  a:first-of-type {
    margin-right: 1.5rem;
  }

  a:last-child {
    margin-left: auto;
  }

  ${theme.breakpoints.tabletLandscapeDown} {
    a {
      margin: 0;
    }

    a:not(:first-of-type) {
      display: none;
    }
  }
`;

export interface HeaderProps {
  banner?: any;
  bannerHeight: number;
  calculatedHeight: number;
  distanceFromTop: number;
  fixNav: boolean;
  isSidebarVisible: boolean;
  location: any;
  targets: any;
  track: (name: string, useComponentName?: string) => void;
  setSidebarVisible: (doit: boolean) => void;
  style: React.CSSProperties;
}

const TrackComponentName = 'Header';

class Header extends React.Component<HeaderProps, {}> {
  constructor(props) {
    super(props);
  }

  private toggleSidebar() {
    this.props.setSidebarVisible(!this.props.isSidebarVisible);
  }

  private closeSidebar(){
    this.props.setSidebarVisible(false);
  }

  public render() {
    const { targets, track } = this.props;
    if (!targets) {
      return null;
    }

    return (
      <React.Fragment>
        <Container className={'header-container'} {...this.props}>
          <NavContainer>
            <BurgerContainer onClick={this.toggleSidebar.bind(this)}>
              <Hamburger color={theme.colors.Gray1} />
            </BurgerContainer>
            <FlexContainer>
              <NavbarLinks
                closeSidebar={this.closeSidebar}
                track={track}
                trackComponentName={TrackComponentName}
                setSidebarVisible={this.props.setSidebarVisible}
              />
            </FlexContainer>
          </NavContainer>
        </Container>
      </React.Fragment>
    );
  }
}

export default withTracking(Header);
